﻿import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export * from 'react-router-dom';

export function useHistory() {
  const navigate = useNavigate();
  const location = useLocation();

  return React.useMemo(() => ({
    push: (to, state) => navigate(to, { state }),
    replace: (to, state) => navigate(to, { replace: true, state }),
    goBack: () => navigate(-1),
    go: (delta) => navigate(delta),
    location,
  }), [navigate, location]);
}

export function withRouter(Component) {
  return function WrappedComponent(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const history = React.useMemo(() => ({
      push: (to, state) => navigate(to, { state }),
      replace: (to, state) => navigate(to, { replace: true, state }),
      goBack: () => navigate(-1),
      go: (delta) => navigate(delta),
      location,
    }), [navigate, location]);

    return (
      <Component
        {...props}
        history={history}
        location={location}
        match={{ params, isExact: true, path: '', url: location.pathname }}
      />
    );
  };
}

export { Routes as Switch } from 'react-router-dom';
